import { Repository } from "../../adapters/repository";
import { present } from "../../../utils/presenter";
import { Interactor } from "./types";

function createInteractor(repository: Repository): Interactor {
  return () =>
    present(
      repository
        .getChatConversations()
        .then((conversations) => ({ conversations }))
        .catch((error) => Promise.reject({ error })),
    );
}

export type { Interactor };

export { createInteractor };
